module.exports = __webpack_public_path__ + "img/code.deb1cb55.png";